// Service de gestion des recettes.
// Appelle désormais l'API PHP/MySQL (XAMPP) au lieu de Supabase.
// L'URL de base est configurable via la variable REACT_APP_API_URL.

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost/tartina-api';
const ENDPOINT = `${API_BASE}/recipes.php`;

// Effectue une requête et renvoie le JSON, en levant une erreur lisible si besoin.
async function request(url, options = {}) {
  const response = await fetch(url, options);

  if (!response.ok) {
    let message = `Erreur ${response.status}`;
    try {
      const body = await response.json();
      if (body && body.error) message = body.error;
    } catch (_) {
      /* réponse non JSON : on garde le message par défaut */
    }
    throw new Error(message);
  }

  return response.json();
}

export const recipeService = {
  // Récupérer toutes les recettes
  async getRecipes() {
    return request(ENDPOINT);
  },

  // Récupérer les recettes avec filtre de prix
  async getRecipesByBudget(maxPrice) {
    return request(`${ENDPOINT}?max_cost=${encodeURIComponent(maxPrice)}`);
  },

  // Récupérer les recettes par catégorie
  async getRecipesByCategory(category) {
    return request(`${ENDPOINT}?category=${encodeURIComponent(category)}`);
  },

  // Récupérer les recettes par occasion/événement
  async getRecipesByEvent(event) {
    return request(`${ENDPOINT}?event=${encodeURIComponent(event)}`);
  },

  // Récupérer une recette spécifique par ID
  async getRecipeById(id) {
    return request(`${ENDPOINT}?id=${encodeURIComponent(id)}`);
  },

  // Ajouter une nouvelle recette
  async addRecipe(recipe) {
    return request(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(recipe),
    });
  },

  // Recherche de recettes par texte
  async searchRecipes(query) {
    return request(`${ENDPOINT}?search=${encodeURIComponent(query)}`);
  },

  // Suggestions de recettes selon le budget (5 mieux notées)
  async getSuggestedRecipesByBudget(budget) {
    return request(`${ENDPOINT}?suggest=${encodeURIComponent(budget)}`);
  },

  // Récupérer les dernières recettes ajoutées
  async getLatestRecipes(limit = 3) {
    return request(`${ENDPOINT}?latest=${encodeURIComponent(limit)}`);
  },

  // Récupérer les recettes les mieux notées
  async getTopRatedRecipes(limit = 3) {
    return request(`${ENDPOINT}?top=${encodeURIComponent(limit)}`);
  },
};
